import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Footer from './components/Footer';

const RefundPage = () => {
  return (
    <div className="app-container" data-theme="dark" style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        <Link to="/">
          <Button variant="ghost" style={{ marginBottom: '1.5rem' }} data-testid="refund-back-btn">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar ao inicio
          </Button>
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '2rem' }}>
          <RefreshCw className="w-8 h-8" style={{ color: '#00ffff' }} />
          <h1 style={{ fontSize: '1.75rem', fontWeight: '700' }}>Política de Reembolso</h1>
        </div>

        <div style={{ color: '#ccc', lineHeight: '1.8', fontSize: '0.95rem' }}>
          <p style={{ color: '#888', marginBottom: '2rem' }}>Última atualização: Dezembro de 2025</p>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>1. Assinaturas</h2>
            <p>A <strong>VLM Corp.</strong>, fundadora da <strong>Atlas.IA</strong>, oferece as seguintes condições de reembolso para assinaturas:</p>
            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}><strong>Primeiros 7 dias:</strong> Reembolso integral para novas assinaturas, sem perguntas. Basta solicitar por email.</li>
              <li style={{ marginBottom: '0.5rem' }}><strong>Apos 7 dias:</strong> Não há reembolso parcial. Você pode cancelar a assinatura a qualquer momento e continuara tendo acesso ate o final do período pago.</li>
              <li style={{ marginBottom: '0.5rem' }}><strong>Renovação automática:</strong> As assinaturas são renovadas automaticamente. Recomendamos cancelar antes da data de renovacao se não desejar continuar.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>2. Compra de Creditos Avulsos</h2>
            <p>Créditos adquiridos avulsamente (fora do plano de assinatura):</p>
            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}><strong>Créditos não utilizados:</strong> Reembolso integral se solicitado em ate 48 horas apos a compra e nenhum crédito tiver sido consumido.</li>
              <li style={{ marginBottom: '0.5rem' }}><strong>Créditos parcialmente utilizados:</strong> Não há reembolso para créditos já consumidos.</li>
              <li style={{ marginBottom: '0.5rem' }}><strong>Créditos não expiram:</strong> Os créditos comprados avulsamente não possuem data de validade.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>3. Sessões de Consultoria Humana</h2>
            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}><strong>Cancelamento com 24h de antecedência:</strong> Reembolso integral ou reagendamento sem custo.</li>
              <li style={{ marginBottom: '0.5rem' }}><strong>Cancelamento com menos de 24h:</strong> Será cobrada 50% do valor da sessão.</li>
              <li style={{ marginBottom: '0.5rem' }}><strong>Não comparecimento:</strong> Não há reembolso.</li>
              <li style={{ marginBottom: '0.5rem' }}><strong>Insatisfação com o serviço:</strong> Caso não esteja satisfeito com a consultoria, entre em contato em ate 48h para análise de reembolso.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>4. Plano Gratuito</h2>
            <p>O plano gratuito não envolve pagamento, portanto nao se aplica política de reembolso. Você pode utilizar os 10 créditos mensais sem compromisso.</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>5. Problemas Técnicos</h2>
            <p>Caso enfrente problemas técnicos que impeçam o uso do servico (indisponibilidade prolongada, erros de sistema, etc.), a Atlas.IA podera conceder créditos compensatórios ou reembolso proporcional, a seu critério.</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>6. Como Solicitar Reembolso</h2>
            <p>Para solicitar reembolso, utilize o sistema integrado na plataforma:</p>
            <div style={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: '8px', padding: '1rem', marginTop: '0.75rem' }}>
              <p style={{ color: '#ccc' }}>Acesse <strong style={{ color: '#00ffff' }}>Reembolso</strong> no menu lateral da plataforma, selecione o motivo e envie sua solicitação.</p>
              <p style={{ marginTop: '0.5rem', color: '#aaa', fontSize: '0.85rem' }}>Sua solicitação será registrada e você poderá acompanhar o status em tempo real.</p>
            </div>
            <p style={{ marginTop: '0.75rem', color: '#ccc' }}>Prazo de resposta: até 5 dias úteis. Reembolsos aprovados são processados pelo Stripe em até 10 dias úteis.</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>7. Disposições Gerais</h2>
            <p style={{ color: '#ccc' }}>A <strong>VLM Corp.</strong> reserva-se o direito de alterar esta política de reembolso a qualquer momento, mediante aviso prévio aos usuários. A versão mais recente estará sempre disponível nesta página.</p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RefundPage;
